module.exports = __webpack_public_path__ + "img/ad5_5.3d19d7c2.jpg";